import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Breadcrumbs } from 'components/no-auth/common/breadcrumbs/Breadcrumbs';
import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { LightButton } from 'components/no-auth/common/fromAuth/LightButton/LightButton';
import { LightFixedBottomPanel } from 'components/no-auth/common/fromAuth/LightFixedBottomPanel/LightFixedBottomPanel';
import { PromoIcon } from 'components/no-auth/common/promo-icon/PromoIcon';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { PromoText } from 'components/no-auth/common/promo-text/PromoText';
import { PromoRow } from 'components/no-auth/common/PromoRow/PromoRow';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { ZendeskHelpLink } from 'components/no-auth/help/styles';
import ZendeskHelpSearch from 'components/no-auth/help/ZendeskHelpSearch';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { toggleChat } from 'actions/chatAction';

import { getLangCountryPrefix } from 'helpers/utils';

const ZendeskHelpSectionPage = (props) => {
    let { sectionId } = useParams();
    const sectionIdNumber = Number(sectionId);
    const section = props.sections?.find((s) => s.id === sectionIdNumber);

    const url = `${getLangCountryPrefix(props.lang, props.country)}/help`;

    const articles = props.articles?.map((article) => {
        return (
            <PromoRow indent="adaptive-24-32" key={article.id} lastChildNoMargin>
                <ZendeskHelpLink href={`${url}/category/${props.category.id}/section/${sectionId}/article/${article.id}`}>
                    <PromoText>
                        {article.promoted && <PromoIcon name="star-filled" color="primary" size="16px" rightIndent="8px" />}
                        {article.name}
                    </PromoText>
                    <PromoIcon name="chevron-right" size="16px" />
                </ZendeskHelpLink>
            </PromoRow>
        );
    });

    const breadcrumbs = [{ name: 'Paysend', url: url }, { name: props.category?.name, url: `${url}/category/${props.category.id}` }, { name: section?.name }];

    return (
        <PromoPageContainer hasTopPadding>
            <ColoredSectionContainer dimension="average" bottomPadding noTopPadding>
                <ZendeskHelpSearch />
                <Breadcrumbs breadcrumbsItems={breadcrumbs} />
                <HeadingSection title={section?.name} titleTag={'h1'} />
                <PromoRow indent="64px">{articles}</PromoRow>
            </ColoredSectionContainer>
            {props.showZendeskChat && (
                <LightFixedBottomPanel pressedAboveCookieButton>
                    <LightButton raised={true} caption={props.chatButton} onClick={() => props.toggleChat(true)} />
                </LightFixedBottomPanel>
            )}
        </PromoPageContainer>
    );
};

const mapStateToProps = ({ extra }) => ({
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    articles: extra?.zendeskHelpData?.articles,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
    chatButton: extra?.strapiApi?.chat_btn,
    showZendeskChat: extra?.noAuthFooter?.showZendeskChat,
});

export default connect(mapStateToProps, { toggleChat })(NotAuthBasePage(ZendeskHelpSectionPage));
